import type { StaffSession } from '@api/types'
import { readJson, writeJson } from './storage'

const KEY = 'veracruz.staffSession'

const isSession = (value: unknown): value is StaffSession => {
	const v = value as StaffSession | null
	return (
		typeof v?.token === 'string' &&
		v.token.length > 0 &&
		typeof v.expiresAt === 'string' &&
		typeof v.user?.name === 'string' &&
		typeof v.user?.email === 'string'
	)
}

// La sesión vale hasta su caducidad (spec `staff-auth`: 24 h, sin renovación). Una fecha
// ilegible cuenta como caducada.
export const isExpired = (session: StaffSession, now: Date = new Date()): boolean => {
	const expires = Date.parse(session.expiresAt)
	return Number.isNaN(expires) || expires <= now.getTime()
}

// Sesión del personal guardada en este navegador; caducada o corrupta → ninguna (y se borra).
export const readStaffSession = (
	storage: Storage | undefined = globalThis.localStorage,
	now: Date = new Date()
): StaffSession | null => {
	const stored = readJson<unknown>(KEY, null, storage)
	if (stored === null) return null
	if (isSession(stored) && !isExpired(stored, now)) return stored
	writeJson(KEY, null, storage)
	return null
}

export const saveStaffSession = (session: StaffSession, storage: Storage | undefined = globalThis.localStorage) =>
	writeJson(KEY, session, storage)

// Cerrar sesión es descartar el token: el servidor no guarda sesiones y el token caduca solo.
export const clearStaffSession = (storage: Storage | undefined = globalThis.localStorage) =>
	writeJson(KEY, null, storage)
